import axios from 'axios';

const API_URL = '/api/teachers';
 
export const getTeachers = async () => {
  const { data } = await axios.get(API_URL);
  return data;
}; 